<mat-tab-group>

    <mat-tab label="Special Message Management">
        <app-response-text [lambdaMessage]="lambdaMessage" [lambdaError]="lambdaError"></app-response-text>
        <br>
        <div class="managementTab">
                <div class="row padded">
                    <div class="column">
                        <div id="customerAgent">
                            <select [(ngModel)]="selectedType">
                                <option value="" disabled selected hidden>Select Type</option>
                                <option ngValue="agent">Agent</option>
                                <option ngValue="customer">Customer</option>
                            </select>
                        </div>
                        <div id="customerAgent">                
                        <select [(ngModel)]="selectedLOB" (ngModelChange)="changeLOB()">
                            <option value="" disabled selected hidden>Select LOB</option>
                            <option class="custom-option" *ngFor="let lob of lobList" [ngValue]="lob[1]" >{{lob[0]}}</option>
                        </select>
                    </div>
                    </div>
                    <div id="lobQueueSelector">
                        <div class=column>
                            <div id="customerAgent">
                                <select [(ngModel)]="selectedGroup" [disabled]="!selectedLOB" (ngModelChange)="groupsSelected = addToList(selectedGroup, groupsSelected)">
                                    <option value="" disabled selected hidden>Select Group</option>
                                    <option class="custom-option" *ngFor="let group of groups" [ngValue]="group" [hidden]="isSelected(group, groupsSelected)">{{group.groupName}}</option>
                                </select>
                            </div>
                            <div class="list">
                                <div class="listItem" *ngFor="let group of groupsSelected">{{group.groupName}}<mat-icon class="closeIcon" (click)="groupsSelected = removeFromList(group, groupsSelected)">close</mat-icon></div>
                            </div>
                        </div>
                        <div class="centerVert">
                            And/Or
                        </div>
                        <div class=column>
                            <div id="customerAgent">
                                <select [(ngModel)]="selectedQueue" [disabled]="!selectedLOB" (ngModelChange)="queuesSelected = addToList(selectedQueue, queuesSelected)">
                                    <option value="" disabled selected hidden>Select Queue</option>
                                    <option class="custom-option" *ngFor="let queue of queues" [ngValue]="queue" [hidden]="isSelected(queue, queuesSelected)">{{queue.queueName}}</option>
                                </select>    
                            </div>
                            <div class="list">
                                <div class="listItem" *ngFor="let queue of queuesSelected">{{queue.queueName}} <mat-icon class="closeIcon" (click)="queuesSelected = removeFromList(queue, queuesSelected)">close</mat-icon></div>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div id="outageType">
                            <select [(ngModel)]="specialMessageTypeSelected">
                                <option value="" disabled selected hidden>Select Special Message</option>
                                <option class="custom-option" *ngFor="let type of filteredTypeData" [hidden]="type.LOB != selectedLOB || !type.enabled" [ngValue]="type">{{type.type}}</option>
                            </select>
                        </div>
                        <input type="text" [(ngModel)]="serviceNow" placeholder="Service Now (Optional)">
                        <button mat-raised-button color="primary" id="activate" (click)="submitSpecialMessage()">Activate</button>
                    </div>
                </div>
            <div class="column padded">
                <mat-tab-group>
                    <mat-tab label="Active">
                        <div id="table">
                            <app-mat-data-grid 
                                class="page-data-grid"
                                [formValid]="true"
                                [header]="header"
                                [(dataSource)]="activeSpecialMessageData" 
                                [displayedColumns]="['type', 'groups', 'queues', 'LOB','specialMessage.type', 'serviceNow', 'active', 'created', 'creator', 'lastUpdated', 'updatedBy']"   
                                [columnNames]="['Type', 'Groups', 'Queues', 'LOB', 'Special Message', 'Service Now', 'Active', 'Created', 'Creator', 'Last Updated', 'Updated By']"
                                [editDefinition]="{'active': active, 'serviceNow': serviceNowTicket}"
                                [columnFormatters]="{'LOB': formatLOBFunction, 'groups': formatGroupFunction, 'queues': formatQueueFunction}"
                                [pageSizeOptions] = "[5, 15, 25, 50]"
                                [buttonConfig]="{
                                    edit: {show: true},
                                    delete: {show:false},
                                    create: {show: false}
                                }"
                                [objectBluePrint]="{
                                    type: selectedType,
                                    LOB: selectedLOB,
                                    groups: groupsSelected,
                                    queues: queuesSelected,
                                    specialMessage: specialMessageTypeSelected
                                }"
                                (buttonClick)="handleSpecialMessageButtonEvent($event)">
                            </app-mat-data-grid>
                            <ng-template let-element #active>
                                <mat-slide-toggle [(ngModel)]="element.active">Active</mat-slide-toggle>
                            </ng-template>
                            <ng-template let-element #serviceNowTicket>
                                <input type="text" [(ngModel)]="element.serviceNow" placeholder="Service Now">
                            </ng-template>
                            <ng-template #header>
                                <button mat-raised-button color="primary" (click)="buildCSV();">Download CSV</button>
                            </ng-template>
                    </div>
                </mat-tab>
                <mat-tab label="Inactive">
                    <div id="table">
                        <app-mat-data-grid 
                            class="page-data-grid"
                            [header]="header"
                            [formValid]="true"
                            [(dataSource)]="inactiveSpecialMessageData" 
                            [displayedColumns]="['type', 'groups', 'queues', 'LOB','specialMessage.type', 'serviceNow', 'active', 'created', 'creator', 'lastUpdated', 'updatedBy']"   
                            [columnNames]="['Type', 'Groups', 'Queues', 'LOB', 'Special Message', 'Service Now', 'Active', 'Created', 'Creator', 'Last Updated', 'Updated By']"
                            [columnFormatters]="{'LOB': formatLOBFunction, 'groups': formatGroupFunction, 'queues': formatQueueFunction}"
                            [pageSizeOptions] = "[5, 15, 25, 50]"
                            [buttonConfig]="{
                                edit: {show: false},
                                delete: {show:false},
                                create: {show: false}
                            }"

                            [objectBluePrint]="{
                                type: selectedType,
                                LOB: selectedLOB,
                                groups: groupsSelected,
                                queues: queuesSelected,
                                specialMessage: specialMessageTypeSelected
                            }"
                            (buttonClick)="handleSpecialMessageButtonEvent($event)">
                        </app-mat-data-grid>
                </div>
                </mat-tab>
                </mat-tab-group>
                <!-- <ng-template #header>
                    <span>
                        Active only:
                        <input type="checkbox" [(ngModel)]="activatedOnly" (ngModelChange)="customFilter();">
                        Inactive only:
                        <input type="checkbox" [(ngModel)]="deactivatedOnly" (ngModelChange)="customFilter();">
                    </span>
                </ng-template> -->
            </div>


        </div>

    </mat-tab>
    <mat-tab label="Special Messages">
        <app-response-text [lambdaMessage]="lambdaMessage" [lambdaError]="lambdaError"></app-response-text>
        <br>
        <div fxLayout="row" fxLayoutAlign="center"> 
            <app-mat-data-grid 
                class="page-data-grid"
                [formValid]="form.valid"
                [headerTwo]="headerTwo"
                [(dataSource)]="filteredTypeData" 
                [displayedColumns]="['LOB', 'type', 'message', 'enabled', 'created', 'creator', 'lastUpdated', 'updatedBy']"   
                [columnNames]="['Special Message LOB', 'Type', 'Message', 'Enabled', 'Created', 'Creator', 'Last Updated', 'Updated By']" 
                [editDefinition]="{'type': type, 'message': message, 'LOB': LOB, 'enabled': enabled}"
                [columnFormatters]="{'LOB': formatLOBFunction}"
                [pageSizeOptions] = "[5, 10, 15]"
                [buttonConfig]="{
                    edit: {show: canEditMessages()},
                    delete: {show:false},
                    create: {show: canEditMessages()}
                }"

                (buttonClick)="handleButtonEvent($event)">
            </app-mat-data-grid>
        </div>
        <!-- type column -->
        <ng-template #type let-element>
            <form [formGroup]="form" [hidden]="!creatingRow">
                <input type="text" [(ngModel)]="element.type" formControlName="type">
            </form>
            <span *ngIf="!creatingRow">
                {{element.type}}
            </span>
        </ng-template>

        <!-- message column -->
        <ng-template #message let-element>
            <form [formGroup]="form">
                <textarea type="text" [(ngModel)]="element.message" formControlName="message"></textarea>
            </form>
        </ng-template>


        <!-- enabled column -->
        <ng-template #enabled let-element>
            <form [formGroup]="form">
                <select [(ngModel)]="element.enabled" class="small" formControlName="enabled">
                    <option [ngValue]="true">True</option>
                    <option [ngValue]="false">False</option>
                </select>
            </form>
        </ng-template>

        <!-- LOB column -->
        <ng-template #LOB let-element>
            <form [formGroup]="form" [hidden]="!creatingRow">
                <select [(ngModel)]="element.LOB" class="small" formControlName="LOB">
                    <option class="custom-option" *ngFor="let lob of lobList" [ngValue]="lob[1]">{{lob[0]}}</option>
                </select>
            </form>
            <span *ngIf="!creatingRow">
                {{formatLOBFunction(element.LOB)}}
            </span>
        </ng-template>
        <ng-template #headerTwo>
            <div class="my-message">{{getErrorMessage()}}</div>
        </ng-template>
    </mat-tab>
    
</mat-tab-group>
<a id="downloadLink" hidden></a>